import {
  fetchAds,
  getOfferMonetizationStrategy,
  UniversalAdWidget,
} from "@ux-dri/universal-ad-widget";
import React, { useEffect, useState, useCallback } from "react";
import { Settings } from "../config";
import classes from "./GDAds.module.scss";
import { createBaseLanderEvent } from "../commons/LanderEvent";
import { EventType } from "../commons/Constants";
import { postEvent } from "../commons/EventHelper";

const adPlacementKey = "gd-parking-lander-pos1";
const fakeExpId = "gdAds";

export const GDAds = ({ landerConfig }) => {
  const { UNIVERSAL_AD_WIDGET_CONFIG: universalAdWidgetConfig } = Settings;
  // Get default monetization strategy by passing fake state for now
  const { omsId, presentationStrategy } = getOfferMonetizationStrategy(
    {
      hivemind: {
        cohorts: {
          [fakeExpId]: {
            cohortId: "",
            data: {},
          },
        },
      },
    },
    fakeExpId
  );

  // UAW local state
  const [adsResponse, setAdsResponse] = useState<any>();
  const [adsLoading, setAdsLoading] = useState(true);
  const [adsFetchCalled, setAdsFetchCalled] = useState(false);

  const trackEvent = useCallback(
    (eventType: string) => {
      const event = createBaseLanderEvent(eventType, {
        ...landerConfig,
        adSense: null,
      });
      postEvent(Settings.EVENT_PUBLISH_API, event);
    },
    [landerConfig]
  );

  useEffect(() => {
    if (!adsFetchCalled && omsId && universalAdWidgetConfig) {
      setAdsFetchCalled(true);
      fetchAds({
        adPlacementKey,
        universalAdWidgetConfig,
        omsId,
        presentationStrategy,
        setAdsResponse,
        setAdsLoading,
      });
    }
  }, [omsId, universalAdWidgetConfig, adsFetchCalled, presentationStrategy]);

  useEffect(() => {
    // fetchAds has finished
    if (!adsLoading && adsResponse) {
      trackEvent(EventType.GD_AD_VISIT);
    }
  }, [adsLoading, adsResponse, trackEvent]);

  const handleAdClick = () => {
    trackEvent(EventType.GD_AD_CLICKED);
  };

  return (
    <div className={ classes.gdAds }>
      <UniversalAdWidget
        adPlacementKey={ adPlacementKey }
        maxAdsToDisplay={
          universalAdWidgetConfig.placements[adPlacementKey]
            .kevelPlacementConfig.count
        }
        loading={ adsLoading }
        omsId={ omsId }
        presentationStrategy={ presentationStrategy }
        emptyComponent={ <div>No offers available</div> }
        onClick={ handleAdClick }
        { ...adsResponse }
      />
    </div>
  );
};
